import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfTablolarDetayParametre = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfTablolarDetayParametreData:{
            Id: "",
            Tablodetayid: "",
            Tablodetayparametreid: "",
            Hesaplamayontemi:"",
            Sirano: 0,
            Deleted: false,
            
          },
        FormDataType:{ 
          Tablodetayid:{FieldName:"Tablodetayid",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetayParametre.AddEdit.Tablodetayid'),ComboDataArray:[]},
          Tablodetayparametreid:{FieldName:"Tablodetayparametreid",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetayParametre.AddEdit.Tablodetayid'),ComboDataArray:[]},
          Hesaplamayontemi:{FieldName:"Hesaplamayontemi",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetayParametre.AddEdit.Hesaplamayontemi'),ComboDataArray:[]},
          Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetayParametre.AddEdit.Sirano'),FieldType:"number"},
        },
        

        hesap_yontemleri: [
          { Id:"0",  Value:"Seçiniz" },
          { Id:"1",  Value:"Kayıt Sayısı" },
          { Id:"2",  Value:"Değer Toplamı" }
        ]

   
      }
    },
    validations:{ 
        FormData: {
          Tablodetayid: { required },
          Tablodetayparametreid: { required },
          Sirano: { required },
          Hesaplamayontemi:{}
        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }

      this.ActionsGet({"Service":"StrPerfTablolarDetay","Page":Page}).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Tablodetayid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
          }    
      }); 

      this.ActionsGet({"Service":"StrPerfTablolarDetayParametreTanim","Page":Page}).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Tablodetayparametreid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Parametreadi})
          }    
      }); 

      for(var i=0; i<this.hesap_yontemleri.length; i++)
            {
                this.FormDataType.Hesaplamayontemi.ComboDataArray.push ({Id:this.hesap_yontemleri[i].Id,Value:this.hesap_yontemleri[i].Value})
          
            }
      
    }


}
export default StrPerfTablolarDetayParametre